export default __webpack_public_path__ + "static/media/sample-id-document.e719f0c5.png";